// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__PrintDocumentsComponent__printAppBtn{margin-left:20px}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/premier-capability-policyjob-react/components/PrintDocumentsComponent/PrintDocumentsComponent.module.scss"],"names":[],"mappings":"AAEA,2CACE,gBAAA","sourcesContent":["@import \"~@jutro/theme/assets/sass/helpers\";\n\n.printAppBtn {\n  margin-left: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"printAppBtn": "app__PrintDocumentsComponent__printAppBtn"
};
export default ___CSS_LOADER_EXPORT___;
